import React from "react";

function StatusProgress({ status = "For Coordinator", object }) {
  const statuses = [
    { status: "For Interview", label: "Initial Interview" },
    { status: "For Coordinator", label: "Assigned Coordinator" },
    { status: "For Endorsement", label: "Endorsement" },
    { status: "On-boarding", label: "On Boarding" },
    { status: "Hired", label: "Hired" },
  ];

  const currentIndex = statuses.findIndex((s) => s.status === status);
  const isInterviewed = object?.interviewForm || false;
  const hasCoordinator = object?.coordinator || false;
  const isForEndorsement = object?.startDate || false;
  const isForOnboarding = object?.onBoardStartTime || false;
  const isHired = status === "Hired";
  const isNotHired = status === "Not Hired";

  const completedSteps = [
    isInterviewed,
    hasCoordinator,
    isForEndorsement,
    isForOnboarding,
    isHired,
  ];

  return (
    <div className="card">
      <div className="card-body">
        <h6 className="text-center text-uppercase fw-semibold text-muted mb-4">
          Application Status
        </h6>

        <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 pb-5">
          {statuses.map((s, index) => {
            const isCompleted = completedSteps[index];
            const isCurrent = index === currentIndex;
            const isNext = index === currentIndex + 1;

            const showRedX = isNotHired && !isCompleted;

            return (
              <div
                key={s.status}
                className="d-flex gap-2 align-items-center position-relative mb-3"
              >
                <div
                  className={`d-flex align-items-center justify-content-center rounded-circle fw-bold flex-shrink-0
                    ${
                      showRedX
                        ? "bg-danger text-white"
                        : isCompleted
                        ? "bg-success text-white"
                        : isNext
                        ? "bg-light text-secondary"
                        : "bg-light text-secondary"
                    }`}
                  style={{
                    width: "2.2rem",
                    height: "2.2rem",
                    fontSize: "1.2rem",
                    transition: "all 0.3s ease",
                  }}
                >
                  {showRedX ? (
                    <i className="bi bi-x-lg"></i>
                  ) : isCompleted ? (
                    <i className="bi bi-check-lg"></i>
                  ) : (
                    index + 1
                  )}
                </div>

                <div
                  className="position-absolute text-center fw-medium"
                  style={{
                    top: "3rem",
                    fontSize: "0.8rem",
                    left: "-2rem",
                    width: "6rem",
                    color: showRedX
                      ? "#dc3545"
                      : isCompleted
                      ? "#198754"
                      : "#6c757d",
                  }}
                >
                  {s.label}
                </div>

                {index < statuses.length - 1 && (
                  <div
                    className="mx-2 flex-grow-1"
                    style={{
                      height: "2px",
                      minWidth: "2rem",
                      backgroundColor: showRedX
                        ? "#dc3545"
                        : isCompleted
                        ? "#198754"
                        : "#dee2e6",
                      transition: "all 0.3s ease",
                    }}
                  ></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default StatusProgress;
